export const MODAL_TYPE_CONFIRMATION = "confirmation";
export const MODAL_TYPE_ERROR = "error";